/* ==========================================================================
   RasCommerce — AJAX cart
   ========================================================================== */
(function () {
  'use strict';

  var RC = (window.RC = window.RC || {});
  var DRAWER_SECTION = 'cart-drawer';

  var state = {
    busy: false
  };

  /* ------------------------------------------------------------- Helpers */

  function drawerEl() {
    return document.querySelector('[data-rc-cart-drawer]');
  }

  function openDrawer() {
    var el = drawerEl();
    if (!el || !window.bootstrap) return;
    window.bootstrap.Modal.getOrCreateInstance(el).show();
  }

  function updateCounts(cart) {
    document.querySelectorAll('[data-rc-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
  }

  /**
   * Replace the drawer markup with freshly rendered HTML from the
   * Section Rendering API, preserving the open state.
   */
  function renderDrawer(sectionHTML) {
    var current = drawerEl();
    if (!current || !sectionHTML) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(sectionHTML, 'text/html');
    var fresh = doc.querySelector('[data-rc-cart-drawer]');
    if (!fresh) return;

    var wasOpen = current.classList.contains('show');

    // Swap only the inner content so the Bootstrap modal instance survives.
    current.innerHTML = fresh.innerHTML;

    if (wasOpen) {
      current.classList.add('show');
    }

    document.dispatchEvent(new CustomEvent('rc:cart:rendered', { detail: { drawer: current } }));
    loadRecommendations();
  }

  function requestSections() {
    return [DRAWER_SECTION];
  }

  function handleError(error) {
    var message = (error && error.data && error.data.description) || (error && error.message) || RC.strings.cartError;
    RC.toast(message, 'error');
  }

  /* -------------------------------------------------------------- Add API */

  RC.cart = RC.cart || {};

  RC.cart.add = function (payload, options) {
    options = options || {};
    if (state.busy) return Promise.resolve();
    state.busy = true;

    var body = Object.assign({}, payload, { sections: requestSections(), sections_url: window.location.pathname });

    return RC.fetchJSON(RC.routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify(body)
    })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections[DRAWER_SECTION]);
        return RC.cart.get();
      })
      .then(function (cart) {
        updateCounts(cart);
        document.dispatchEvent(new CustomEvent('rc:cart:updated', { detail: { cart: cart } }));

        if (RC.settings.cartType === 'drawer' && options.openDrawer !== false) {
          openDrawer();
        } else if (options.openDrawer !== false) {
          window.location.href = RC.routes.cart;
        } else {
          RC.toast(RC.strings.addedToCart, 'success');
        }
        return cart;
      })
      .catch(handleError)
      .finally(function () {
        state.busy = false;
      });
  };

  RC.cart.get = function () {
    return RC.fetchJSON(RC.routes.cart + '.js');
  };

  RC.cart.change = function (payload) {
    if (state.busy) return Promise.resolve();
    state.busy = true;

    var body = Object.assign({}, payload, { sections: requestSections(), sections_url: window.location.pathname });

    return RC.fetchJSON(RC.routes.cartChange, {
      method: 'POST',
      body: JSON.stringify(body)
    })
      .then(function (cart) {
        if (cart.sections) renderDrawer(cart.sections[DRAWER_SECTION]);
        updateCounts(cart);
        document.dispatchEvent(new CustomEvent('rc:cart:updated', { detail: { cart: cart } }));
        refreshCartPage();
        return cart;
      })
      .catch(handleError)
      .finally(function () {
        state.busy = false;
      });
  };

  RC.cart.updateNote = function (note) {
    return RC.fetchJSON(RC.routes.cartUpdate, {
      method: 'POST',
      body: JSON.stringify({ note: note })
    }).catch(handleError);
  };

  /**
   * The cart page renders its own section; refresh it in place after a change
   * so the drawer and the page never disagree.
   */
  function refreshCartPage() {
    var cartSection = document.querySelector('[data-rc-cart-page]');
    if (!cartSection) return;

    var sectionId = cartSection.dataset.sectionId;
    if (!sectionId) return;

    RC.fetchSection(sectionId, RC.routes.cart)
      .then(function (doc) {
        var fresh = doc.querySelector('[data-rc-cart-page]');
        if (fresh) cartSection.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        window.location.reload();
      });
  }

  /* ------------------------------------------------------- Event wiring */

  // Add to cart forms (product page, quick view, quick add)
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-rc-product-form]');
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-rc-form-error]');
    if (errorBox) errorBox.classList.remove('is-visible');

    var formData = new FormData(form);
    var payload = { items: [{}] };
    var item = payload.items[0];

    formData.forEach(function (value, key) {
      if (key === 'id') {
        item.id = value;
      } else if (key === 'quantity') {
        item.quantity = parseInt(value, 10) || 1;
      } else if (key === 'selling_plan') {
        if (value) item.selling_plan = value;
      } else if (key.indexOf('properties[') === 0) {
        var propName = key.slice(11, -1);
        item.properties = item.properties || {};
        item.properties[propName] = value;
      }
    });

    if (!item.id) {
      if (errorBox) {
        errorBox.textContent = RC.strings.unavailable;
        errorBox.classList.add('is-visible');
      }
      return;
    }

    if (button) {
      button.classList.add('rc-loading');
      button.disabled = true;
    }

    RC.cart.add(payload).finally(function () {
      if (button) {
        button.classList.remove('rc-loading');
        button.disabled = false;
      }
    });
  });

  // Quick add from a product card (single-variant products)
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rc-quick-add]');
    if (!trigger) return;

    event.preventDefault();
    var variantId = trigger.dataset.variantId;
    if (!variantId) return;

    trigger.classList.add('rc-loading');
    RC.cart.add({ items: [{ id: variantId, quantity: 1 }] }).finally(function () {
      trigger.classList.remove('rc-loading');
    });
  });

  // Quantity change inside the drawer or cart page
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-rc-cart-qty]')) return;

    var row = input.closest('[data-rc-cart-item]');
    if (!row) return;

    row.classList.add('rc-updating');

    RC.cart.change({
      line: parseInt(row.dataset.line, 10),
      quantity: parseInt(input.value, 10)
    });
  });

  // Remove a line
  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-rc-cart-remove]');
    if (!remove) return;

    event.preventDefault();
    var row = remove.closest('[data-rc-cart-item]');
    if (!row) return;

    row.classList.add('rc-updating');
    RC.cart.change({ line: parseInt(row.dataset.line, 10), quantity: 0 });
  });

  // Order note
  document.addEventListener('change', function (event) {
    var note = event.target;
    if (!note.matches || !note.matches('[data-rc-cart-note]')) return;
    RC.cart.updateNote(note.value);
  });

  // Terms checkbox gate
  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('[data-rc-checkout]');
    if (!checkout) return;

    var form = checkout.closest('form');
    if (!form) return;

    var terms = form.parentElement.querySelector('[data-rc-cart-terms]') || document.querySelector('[data-rc-cart-terms]');
    if (terms && !terms.checked) {
      event.preventDefault();
      RC.toast(RC.strings.cartError, 'error');
      terms.focus();
    }
  });

  /* ------------------------------------------------------ Recommendations */

  function loadRecommendations() {
    var container = document.querySelector('[data-rc-cart-recommendations]');
    if (!container) return;

    var productId = container.dataset.productId;
    if (!productId) {
      container.innerHTML = '';
      return;
    }

    var url =
      RC.routes.root +
      'recommendations/products?section_id=cart-recommendations&product_id=' +
      productId +
      '&limit=6&intent=complementary';

    RC.fetchText(url)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-rc-recommendations-inner]');
        if (content && content.querySelector('.tf-minicart-recommendations-item')) {
          container.innerHTML = content.innerHTML;
          if (RC.initCarousels) RC.initCarousels(container);
        } else {
          container.innerHTML = '';
        }
      })
      .catch(function () {
        container.innerHTML = '';
      });
  }

  /* --------------------------------------------------- Shipping estimator */

  function initShippingEstimator(scope) {
    var root = scope.querySelector ? scope : document;
    var estimator = root.querySelector('[data-rc-shipping-estimator]');
    if (!estimator || estimator.dataset.rcBound) return;
    estimator.dataset.rcBound = 'true';

    var countrySelect = estimator.querySelector('[data-rc-shipping-country]');
    var provinceSelect = estimator.querySelector('[data-rc-shipping-province]');
    var zipInput = estimator.querySelector('[data-rc-shipping-zip]');
    var button = estimator.querySelector('[data-rc-shipping-calculate]');
    var results = estimator.querySelector('[data-rc-shipping-results]');

    function syncProvinces() {
      if (!countrySelect || !provinceSelect) return;
      var option = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      try {
        provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
      } catch (e) {
        provinces = [];
      }

      provinceSelect.innerHTML = '';
      var wrapper = provinceSelect.closest('.field');

      if (!provinces.length) {
        if (wrapper) wrapper.style.display = 'none';
        return;
      }

      if (wrapper) wrapper.style.display = '';
      provinces.forEach(function (province) {
        var opt = document.createElement('option');
        opt.value = province[0];
        opt.textContent = province[1];
        provinceSelect.appendChild(opt);
      });
    }

    if (countrySelect) {
      countrySelect.addEventListener('change', syncProvinces);
      syncProvinces();
    }

    if (button) {
      button.addEventListener('click', function () {
        if (!results) return;

        button.classList.add('rc-loading');
        results.innerHTML = '';

        var params = new URLSearchParams({
          'shipping_address[country]': countrySelect ? countrySelect.value : '',
          'shipping_address[province]': provinceSelect ? provinceSelect.value : '',
          'shipping_address[zip]': zipInput ? zipInput.value : ''
        });

        RC.fetchJSON(RC.routes.root + 'cart/shipping_rates.json?' + params.toString())
          .then(function (data) {
            var rates = (data.shipping_rates || []).map(function (rate) {
              return '<li>' + rate.name + ': <strong>' + RC.formatMoney(rate.price * 100) + '</strong></li>';
            });
            results.innerHTML = rates.length
              ? '<ul class="rc-shipping-rates">' + rates.join('') + '</ul>'
              : '<p>' + (RC.strings.noShippingRates || 'No shipping rates found.') + '</p>';
          })
          .catch(function () {
            results.innerHTML = '<p>' + RC.strings.cartError + '</p>';
          })
          .finally(function () {
            button.classList.remove('rc-loading');
          });
      });
    }
  }

  /* ----------------------------------------------------------------- Init */

  RC.onSectionLoad(function (scope) {
    initShippingEstimator(scope);
  });

  document.addEventListener('rc:cart:rendered', function () {
    initShippingEstimator(document);
  });

  document.addEventListener('DOMContentLoaded', function () {
    loadRecommendations();
  });
})();
